import { render } from "./Widget8.vue?vue&type=template&id=28363142"
import script from "./Widget8.vue?vue&type=script&lang=ts"
export * from "./Widget8.vue?vue&type=script&lang=ts"
script.render = render

export default script